import React from 'react';
import moment from 'moment';
import TableRow from 'components/shared/index/table_row';
import Cell from 'components/shared/index/table/body_cell';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import { localTime } from 'components/InPersonTraining/shared/LocalTimeAndTimeZone';
import { Icon } from 'ui';

const formatLocalDate = date => {
  if (date) {
    return moment(localTime(date), DateFormat.fixed.ISO8601_LOCAL).format(
      DateFormat.LONG,
    );
  }
  return '-';
};

const formatLastUpdatedBy = (createdBy, lastUpdatedBy) => {
  if (lastUpdatedBy) {
    return lastUpdatedBy.name;
  }
  if (createdBy) {
    return createdBy.name;
  }
  return 'Deleted User';
};

const formatLocalDateWithTime = (createdDate, lastUpdatedDate) => {
  if (lastUpdatedDate === null) {
    return moment(
      localTime(createdDate),
      DateFormat.fixed.ISO8601_LOCAL,
    ).format(DateFormat.LONG_AT_TIME);
  }
  return moment(
    localTime(lastUpdatedDate),
    DateFormat.fixed.ISO8601_LOCAL,
  ).format(DateFormat.LONG_AT_TIME);
};

const formatEventLocation = event => {
  let eventLocation = '';
  const videoAndInPersonMeeting =
    event.location +
    ', ' +
    t('in_person_training.events_dashboard.video_conference');
  const videoMeeting = t(
    'in_person_training.events_dashboard.video_conference',
  );
  const inPersonMeeting = event.location;
  const nextSession = event.next_session;
  const previousSession = event.previous_session;
  const nextSessionHasVideoMeeting = nextSession && nextSession.video_meeting;
  const previousSessionHasVideoMeeting =
    previousSession && previousSession.video_meeting;

  if (
    (nextSessionHasVideoMeeting || previousSessionHasVideoMeeting) &&
    inPersonMeeting
  ) {
    eventLocation = videoAndInPersonMeeting;
  } else if (nextSessionHasVideoMeeting || previousSessionHasVideoMeeting) {
    eventLocation = videoMeeting;
  } else if (inPersonMeeting) {
    eventLocation = inPersonMeeting;
  }

  if (eventLocation === '') {
    eventLocation = '-';
  }

  return eventLocation;
};

const getEventDate = event => {
  if (event.next_session) {
    return formatLocalDate(event.next_session.start_time);
  }
  if (event.previous_session) {
    return formatLocalDate(event.previous_session.start_time);
  }
  return null;
};

const EventRow = ({ event, features }) => (
  <TableRow selectable={false}>
    <Cell size="xl" name="name">
      <a
        aria-label={`Link: ${event.name}`}
        href={routes.IN_PERSON_TRAINING.EVENT(event.id)}
      >
        {event.name}
      </a>
      {event.number_of_sessions > 1 && (
        <div>
          <Icon
            aria-label="Multi-Session Icon"
            name="sessions"
            className="mr-4"
          />
          <span
            aria-label="Multi-Session Event"
            className="Index-tableSecondaryField"
          >
            {t('in_person_training.events.multi_session_event')}
          </span>
        </div>
      )}
    </Cell>
    <Cell size="l" name="start_time" hideBelowXS>
      {getEventDate(event)}
      {event.number_of_sessions > 1 && (
        <div>
          {t('in_person_training.events.more', {
            count: event.number_of_sessions,
          })}
        </div>
      )}
    </Cell>
    <Cell size="l" name="location" hideBelowXS>
      {event.number_of_sessions > 1
        ? t('in_person_training.events.multiple_locations')
        : formatEventLocation(event)}
    </Cell>
    <Cell size="s" name="instructor" hideBelowXS>
      {event.number_of_sessions > 1
        ? t('in_person_training.events.multiple_instructors')
        : event.instructor || '-'}
    </Cell>
    <Cell size="s" name="number_of_registered" hideBelowXS center>
      {event.number_of_registered}
    </Cell>
    <Cell size="s" name="number_of_attendees" hideBelowMD center>
      {event.number_of_attendees}
    </Cell>
    <Cell size="xl" name="date_updated">
      {formatLocalDateWithTime(event.created_at, event.last_updated_at)}
      <div className="Index-tableSecondaryField">
        {`Updated by ${formatLastUpdatedBy(
          event.created_by,
          event.last_updated_by,
        )}`}
      </div>
    </Cell>
  </TableRow>
);

export default EventRow;
